import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _TabComponentMap;
import React, { useCallback } from 'react';
import { Chips } from '@carnica/ui-kit';
import PropTypes from 'prop-types';
import { AutoMetricBlockType, AutoMetricElement, AutoMetricParams } from '@beef/auto-metric';
import { enhancedConnect } from "../../utils";
import { TabTypes, TabsRenderMode, useTabsContext } from "./context";
import { TabsContent } from "./TabsContent";
import { PlainTab } from "./PlainTab";
import { SegmentedTab } from "./SegmentedTab";
var TabComponentMap = (_TabComponentMap = {}, _defineProperty(_TabComponentMap, TabTypes.PLAIN, PlainTab), _defineProperty(_TabComponentMap, TabTypes.CHIPS, Chips), _defineProperty(_TabComponentMap, TabTypes.SEGMENTED, SegmentedTab), _TabComponentMap);
var _TabsItem = function _TabsItem(_ref) {
  var children = _ref.children,
    label = _ref.label,
    id = _ref.id,
    className = _ref.className,
    width = _ref.width;
  var _useTabsContext = useTabsContext(),
    type = _useTabsContext.type,
    mode = _useTabsContext.mode,
    value = _useTabsContext.value,
    onChange = _useTabsContext.onChange,
    isFirst = _useTabsContext.isFirst;
  var tabValue = id || label;
  var isActive = value === null ? isFirst : tabValue === value;
  var handleClick = useCallback(function () {
    return onChange(tabValue);
  }, [tabValue, onChange]);
  var TabComponent = TabComponentMap[type || TabTypes.CHIPS];
  if (mode === TabsRenderMode.TAB) {
    return /*#__PURE__*/React.createElement(AutoMetricElement, {
      params: {
        name: 'Tab',
        id: id,
        label: label
      },
      type: AutoMetricBlockType.ELEMENT,
      "data-t-id": "components-Tabs"
    }, /*#__PURE__*/React.createElement(TabComponent, {
      active: isActive,
      label: label,
      onClick: handleClick,
      width: width,
      "data-t-id": "components-Tabs"
    }));
  }
  return isActive ? /*#__PURE__*/React.createElement(AutoMetricParams, {
    params: {
      activeTab: id !== null && id !== void 0 ? id : label
    }
  }, /*#__PURE__*/React.createElement(TabsContent, {
    className: className,
    "data-t-id": "components-Tabs"
  }, children)) : null;
};
export var TabsItem = enhancedConnect({
  children: PropTypes.node,
  label: PropTypes.string,
  id: PropTypes.string,
  width: PropTypes.string
})(_TabsItem);